module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/h34Nkh/tc-custom/9781488046926.jpg?1705766069146",
      "alt": "This image is the cover for the book Second Chance Temptation, Love in Boston"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Second Chance Temptation, Love in Boston\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Years ago, she left him at the altar.  She. Owes. Him.  Now Tanna Murphy shows up, wanting to make amends? Nothing she could say would salvage Levi Brogan’s broken trust. Or so he says. Yet Levi needs someone at his beck and call for the next six weeks. And he’s discovered the perfect way Tanna can make it all up to him… With desire still burning between them, will temptation lead to their second chance?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joss Wood\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joss loves books, coffee and traveling—especially to the wild places of Southern Africa and, well, anywhere. She’s a wife and a mom to two young adults. She’s also a servant to two cats and a dog the size of a small cow. After a career in local economic development and business, Joss writes full-time from her home in KwaZulu-Natal, South Africa. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0